module.exports = __webpack_public_path__ + "img/times-circle-icon.svg";